import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.config({
  autoSleep: 60,
  force3D: true,
  nullTargetWarn: false,
  trialWarn: false,
  units: {
    left: "%",
    top: "%",
    rotation: "rad",
  },
});

export class MainDialog {
  constructor(el) {
    this.el = el;
    this.dialogBox = el.querySelectorAll("[data-dialog-box]");
    this.bgBox = el.querySelectorAll("[data-dialog-background]");

    this.timeline = null;
  }

  Reset() {
    gsap.set(this.el, { x: "0%" });
    gsap.set(this.dialogBox, { y: 10, opacity: 0 });
    gsap.set(this.bgBox, { opacity: 0 });
    this.timeline != null ? this.timeline.kill() : "";
  }

  Open() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.set(
      this.el,
      {
        x: "-100%",
      },
      "beforeOpen"
    );
    this.timeline.to(
      this.bgBox,
      {
        opacity: 1,
        duration: 0.3,
      },
      "open"
    );
    this.timeline.to(
      this.dialogBox,
      {
        y: 0,
        opacity: 1,
      },
      "open"
    );
  }

  Close() {
    this.timeline != null ? this.timeline.kill() : "";
    this.timeline = gsap.timeline();

    this.timeline.to(
      this.dialogBox,
      {
        y: 10,
        opacity: 0,
      },
      "close"
    );
    this.timeline.to(
      this.bgBox,
      {
        opacity: 0,
        duration: 0.3,
      },
      "close"
    );
    this.timeline.set(
      this.el,
      {
        x: "0%",
      },
      "afterClose"
    );
  }
}
